import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCustomFontPairs = (fontPairs, withPropertyCreation = false) => {
  const actions = fontPairs.map((fontPair) =>
    setSiteMeta(['customization', 'customFontPairs', fontPair.id], fontPair)
  );

  if (withPropertyCreation) {
    actions.unshift(setSiteMeta(['customization', 'customFontPairs'], []));
  }

  return actions;
};

export default createCustomFontPairs;
